import React, { useContext } from 'react';
import { LineupContext, useLineupCountdown } from '../context/LineupContext';
import { pluralizeDays } from '@root/components/RoundSummaries';
import { useTranslation } from '@root/misc/useTranslation';

const Countdown = () => {
  const {d, hh, mm} = useLineupCountdown();

  return <div className="neo__lineupCountdown">
    <strong>{d}</strong>
    <span>{pluralizeDays(d)}</span>
    <strong>{hh}:{mm}</strong>
  </div>
}

export const LineupPhaseAndCountdown: React.FC = () => {
  const { t } = useTranslation();
  const { lineup } = useContext(LineupContext);

  const labelState = lineup?.phase === 'open'
    ? 'countdown'
    : lineup?.phase === 'closed'
      ? 'live'
      : 'justTranslationForPhase';
  const scoresState = lineup?.score_info
    ? 'showScores'
    : 'hide';

  return <div className="neo__lineupPhaseAndC">
    {labelState === 'countdown' &&
      <Countdown />}
    {labelState === 'live' &&
      <div className="neo__lineupPhaseAndC__livePhase">{t("lineup_phase.closed")}</div>}
    {labelState === 'justTranslationForPhase' &&
      <div className="neo__lineupPhaseAndC__phase">{t(`lineup_phase.${lineup?.phase || "waiting"}`)}</div>}

    {scoresState === 'showScores' &&
      <div className="neo__lineupTotalScore">
        <strong>{t("general.points_with_label", { points: (lineup?.score_info?.total_score ?? 0.0).toFixed(1) })}</strong>
      </div>}
  </div>;
};
